import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchNbrPostsApplications } from 'services/recruitersService';
import useUserId from './useUserId2';

const useNbrPostsApplicants = () => {
  const userId = useUserId();
  const [posts, setPosts] = useState(0);
  const [applicants, setApplicants] = useState(0);
  const [disscussions, setDisscussions] = useState(0);
  const [ai_processed_resumes, setAiProcessedResumes] = useState(0);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      if (!userId?.userId) return;
      
      setLoading(true);
      try {
        const data = await fetchNbrPostsApplications(userId.userId);
        setPosts(data.total_posts);
        setApplicants(data.total_applications);
        setDisscussions(data.total_disscusions); 
        setAiProcessedResumes(data.ai_processed_resumes); 
        console.log('total:', data)

      } catch (err) {
        if (err.message === "Unauthorized") {
          navigate("/login");
        } else {
          setError(err.message);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [userId?.userId, navigate]);

  return { posts, applicants,disscussions,ai_processed_resumes, loading, error };
};

export default useNbrPostsApplicants;